import React, { useEffect, useState } from 'react';
import './Section3.css';
import { useTranslation } from 'react-i18next';
import { Card } from 'components';
import { BlindIcon, DownArrow } from 'icons';
import { categories } from 'utils';
import SBCard from 'components/SBCard';
import { DefaultCard } from 'components/DefaultCard';

export const Section3 = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] =
    useState<string>('External Blinds');
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const media = categories[selectedCategory] || [];

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getPreviousIndex = () =>
    currentIndex === 0 ? media.length - 1 : currentIndex - 1;
  const getNextIndex = () =>
    currentIndex === media.length - 1 ? 0 : currentIndex + 1;

  const goToNextSlide = () => setCurrentIndex(getNextIndex());
  const goToPrevSlide = () => setCurrentIndex(getPreviousIndex());

  // Translate media content dynamically
  const translatedMedia = media.map((item) => ({
    ...item,
    title: t(`section3.categories.${selectedCategory}.${item.title}.title`),
    description1: t(
      `section3.categories.${selectedCategory}.${item.title}.description1`,
    ),
    description2: t(
      `section3.categories.${selectedCategory}.${item.title}.description2`,
    ),
    description3: t(
      `section3.categories.${selectedCategory}.${item.title}.description3`,
    ),
    detail1: t(`section3.categories.${selectedCategory}.${item.title}.detail1`),
    detail2: t(`section3.categories.${selectedCategory}.${item.title}.detail2`),
    detail3: t(`section3.categories.${selectedCategory}.${item.title}.detail3`),
    row1: t(`section3.categories.${selectedCategory}.${item.title}.row1`),
    row1_2: t(`section3.categories.${selectedCategory}.${item.title}.row1_2`),
    row1_3: t(`section3.categories.${selectedCategory}.${item.title}.row1_3`),
    // Add other rows as needed
  }));

  return (
    <section className="md:px-mediumPx lg:px-largePx py-[32px] md:py-mediumPy lg:py-largePy bg-gradient-to-b from-[#1E90AA] to-[#0C3A44] lg:min-h-[600px]">
      <div className="relative inline-block mb-5 px-smallPx">
        <button
          className="flex flex-row gap-2 items-center text-[24px] text-white"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <BlindIcon />
          <h1>{t(`section3.categories.${selectedCategory}.name`)}</h1>
          <DownArrow />
        </button>
        {dropdownOpen && (
          <ul className="absolute bg-white text-black w-full mt-2 rounded shadow-md z-10">
            {Object.keys(categories).map((category) => (
              <li
                key={category}
                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                onClick={() => {
                  setSelectedCategory(category);
                  setCurrentIndex(0);
                  setDropdownOpen(false);
                }}
              >
                {t(`section3.categories.${category}.name`)}
              </li>
            ))}
          </ul>
        )}
      </div>
      {selectedCategory === 'External Blinds' ||
      selectedCategory === 'Zip Screen' ? (
        <div className="gallery-screen-wrapper pb-[32px]">
          <div className="gallery-slider">
            <div className="gallery-main-images">
              <button
                className="gallery-arrow left-arrow"
                onClick={goToPrevSlide}
              >
                ❮
              </button>
              <Card
                {...translatedMedia[getPreviousIndex()]}
                className="gallery-side-card"
                contentClassName="hidden md:block"
                imgAlignBottomRight={selectedCategory === 'Zip Screen'} // Pass prop here
              />
              <Card
                {...translatedMedia[currentIndex]}
                className="gallery-center-card"
                imgAlignBottomRight={selectedCategory === 'Zip Screen'} // Pass prop here
              />
              <Card
                {...translatedMedia[getNextIndex()]}
                className="gallery-side-card"
                contentClassName="hidden md:block"
                imgAlignBottomRight={selectedCategory === 'Zip Screen'} // Pass prop here
              />
              <button
                className="gallery-arrow right-arrow"
                onClick={goToNextSlide}
              >
                ❯
              </button>
            </div>
            <div className="gallery-dots mt-5">
              {media.map((_, index) => (
                <span
                  key={index}
                  className={`gallery-dot ${currentIndex === index ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      ) : selectedCategory === 'Self-Bearing Systems' ? (
        <div className="flex flex-col lg:flex-row gap-5 px-5">
          {translatedMedia.map((item, index) => (
            <SBCard key={index} {...item} />
          ))}
        </div>
      ) : (
        <div className="flex px-5 justify-center items-center">
          <DefaultCard
            {...translatedMedia[0]}
            spacey="space-y-2"
            className="gallery-center-card"
            hideDsc={isSmallScreen ? true : false}
          />
        </div>
      )}
    </section>
  );
};

export default Section3;
